export const printIfrStyles = `
@media print {
	@page {
		size: A3 landscape;
		margin: 0.5in;
	}
}

* {
	box-sizing: border-box;
}

body {
	font-family: Arial, sans-serif;
	font-size: 6px;
	line-height: 12px;
	margin: 0;
	padding: 0;
}

.page {
	width: 100%;
	min-height: 100vh;
}

.page-break-after {
	page-break-after: always;
}

.page-break-before {
	page-break-before: always;
}

.print-header {
	text-align: center;
	margin-bottom: 20px;
	border: 2px solid #90caf9;
	padding-bottom: 16px;
	background: #e8f4fd;
	padding: 16px;
	border-radius: 8px;
}

.print-header h1 {
	margin: 0 0 10px 0;
	font-size: 18px;
	font-weight: bold;
	color: #000;
}

.print-subtitle {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 10px;
	font-size: 12px;
	color: #000;
	font-weight: 500;
}

.table-section {
	margin-bottom: 30px;
	border: 1px solid #333;
  border-bottom: none;
	border-radius: 8px;
	overflow: hidden;
}

.table-section h3 {
	margin: 0;
	font-size: 14px;
	font-weight: bold;
	color: #fff;
	background: #64b5f6;
	padding: 12px 16px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

table {
	width: 100%;
	border-collapse: collapse;
	font-size: 8px;
}

th, td {
	border: 1px solid #333;
	padding: 6px 4px;
	text-align: right;
	vertical-align: middle;
}

th {
	background-color: #E9F7FD;
	color: #000;
	font-weight: bold;
	font-size: 8px;
	text-transform: uppercase;
	letter-spacing: 0.3px;
}

.col-label {
	text-align: left !important;
	min-width: 120px;
	max-width: 150px;
	word-wrap: break-word;
}

.col-data {
	min-width: 80px;
	width: 80px;
}

.col-summary {
	min-width: 70px;
	width: 70px;
	font-weight: bold;
	background-color: #E9F7FD;
	color: #000;
}

.row-summary {
	background-color: #E9F7FD;
	color: #000;
	font-weight: bold;
}

.row-summary .col-summary {
	background-color: #E9F7FD;
	color: #000;
}

.data-row:nth-child(even) {
	background-color: #f5f5f5;
}

.data-row:nth-child(odd) {
	background-color: #fff;
}

.data-row .col-label {
	font-weight: 500;
	color: #000;
}

.data-row:nth-child(even) .col-summary {
	background-color: #E9F7FD;
	color: #000;
	font-weight: bold;
}

.data-row:nth-child(odd) .col-summary {
	background-color: #E9F7FD;
	color: #000;
	font-weight: bold;
}

/* Print-specific improvements */
@media print {
	.print-header {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	
	.table-section {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	
	.table-section h3 {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	
	.row-summary {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	
	th {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	
	.col-summary {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	
	.data-row:nth-child(even) {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	
	.data-row:nth-child(even) .col-summary {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	
	.data-row:nth-child(odd) .col-summary {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
}
`;
